import useLocalStorage from './useLocalStorage';

export default () => {
    const [storedQuote, setStoredQuote] = useLocalStorage('storedQuote', {});

    return { storedQuote, setStoredQuote };
};
